(function () {
  const CONTAINER_ID = 'CartDrawer-Upsell';
  const LIMIT = 2;
  let lastProductId = null;

  function formatMoney(cents) {
    const formatted = (cents / 100).toFixed(2);
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active !== 'USD') {
      return formatted + ' ' + window.Shopify.currency.active;
    }
    return '$' + formatted;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getSizedImageUrl(url, size) {
    if (!url) return null;
    return url.replace(/(\.[^.?]+)(\?.*)?$/, `_${size}$1$2`);
  }

  function renderProduct(product) {
    const variant = product.variants.find((productVariant) => productVariant.available) || product.variants[0];
    if (!variant) return '';
    const imgSrc = getSizedImageUrl(product.featured_image, '120x120');
    const price = formatMoney(variant.price);
    const unavailable = variant.available === false;

    return `
      <div class="cart-upsell__product">
        ${imgSrc ? `<img src="${imgSrc}" alt="${escapeHtml(product.title)}" width="56" height="56" class="cart-upsell__image" loading="lazy">` : ''}
        <div class="cart-upsell__info">
          <p class="cart-upsell__title">${escapeHtml(product.title)}</p>
          <p class="cart-upsell__price">${price}</p>
        </div>
        <form action="/cart/add" method="post" class="cart-upsell__form">
          <input type="hidden" name="id" value="${variant.id}">
          <input type="hidden" name="quantity" value="1">
          <button type="submit" class="cart-upsell__btn button button--secondary"${unavailable ? ' disabled' : ''}>
            ${unavailable ? 'Sold out' : 'Add'}
          </button>
        </form>
      </div>`;
  }

  function renderUpsell(products) {
    const container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    if (!products || products.length === 0) {
      container.innerHTML = '';
      return;
    }

    container.innerHTML = `
      <div class="cart-upsell">
        <p class="cart-upsell__heading">You might also like</p>
        <div class="cart-upsell__products">
          ${products.map(renderProduct).join('')}
        </div>
      </div>`;

    container.querySelectorAll('.cart-upsell__form').forEach((form) => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const btn = form.querySelector('button');
        if (btn) { btn.disabled = true; btn.textContent = '✓'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 }),
        })
          .then((r) => r.json())
          .then((item) => {
            if (item.status) throw new Error(item.description || item.message || 'Unable to add item to cart');
            return fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
              .then((response) => response.json())
              .then((sections) => ({ item, sections }));
          })
          .then(({ item, sections }) => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.renderContents({
                id: item.product_id,
                sections,
              });
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-upsell',
              productVariantId: item.variant_id,
              cartData: item,
            });

            if (item.product_id) loadUpsell(item.product_id, true);
          })
          .catch(() => {
            if (btn) { btn.disabled = false; btn.textContent = 'Add'; }
          });
      });
    });
  }

  function loadUpsell(productId, force = false) {
    if (!force && productId === lastProductId) return;
    lastProductId = productId;
    fetch(`/recommendations/products.json?product_id=${productId}&limit=${LIMIT}&intent=related`)
      .then((r) => r.json())
      .then((data) => renderUpsell(data.products || []))
      .catch(() => {});
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
    if (data.source === 'cart-upsell') return;
    const productId = data.cartData && data.cartData.product_id;
    if (productId) loadUpsell(productId);
  });
})();
